/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { real, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const stockMovements = sqliteTable('stock_movements', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  inventory_item_id: text('inventory_item_id'),
  inventory_batch_id: text('inventory_batch_id'),
  source_type: text('source_type'),
  source_id: text('source_id'),
  source_line_id: text('source_line_id'),
  movement_type: text('movement_type'),
  quantity_in: real('quantity_in'),
  quantity_out: real('quantity_out'),
  unit: text('unit'),
  movement_date: text('movement_date'),
  remarks: text('remarks'),
  created_by: text('created_by'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
